import { request } from "./http";
import type { Capabilities, Override, TeamMember } from "./types";

export function listTeam(): Promise<TeamMember[]> {
  return request("/users/");
}

export interface InvitePayload {
  email: string;
  full_name: string;
  role: string;
  phone?: string;
}

export function inviteMember(payload: InvitePayload): Promise<TeamMember> {
  return request("/users/", { method: "POST", body: payload });
}

export function updateMember(id: string, patch: Partial<TeamMember>): Promise<TeamMember> {
  return request(`/users/${id}`, { method: "PATCH", body: patch });
}

export function resendInvite(id: string): Promise<{ ok: boolean; message: string }> {
  return request(`/users/${id}/resend-invite`, { method: "POST" });
}

export function memberCapabilities(id: string): Promise<Capabilities> {
  return request(`/users/${id}/capabilities`);
}

export function listOverrides(id: string): Promise<Override[]> {
  return request(`/users/${id}/overrides`);
}

export function setOverride(id: string, override: Override): Promise<Override> {
  return request(`/users/${id}/overrides`, { method: "PUT", body: override });
}

export function clearOverride(id: string, domain: string, action: string): Promise<{ removed: boolean }> {
  return request(`/users/${id}/overrides`, {
    method: "DELETE",
    params: { domain, action },
  });
}
